import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import PricesButtonGroup from "@components/PricesButtonGroup"
import { isMobileResolution } from "../../../utils/WindowWidth"
import { TableFiltersMobile } from "./TableFiltersMobile"

export const AVAILABLE_RANGES = [
  { id: "daily", text: "range_DAY" },
  { id: "monthly", text: "range_MONTH" },
  { id: "yearly", text: "range_YEAR" },
]

export const TableFilters = ({
  selectCurrency,
  selectRange,
  availableCurrencies,
  mobileMenuAnchorEl,
  mobileMenuOpen,
  onMobileMenuClose,
  localStoragePrefix,
}) => {
  const { t } = useTranslation()

  const currencyButtonGroup = availableCurrencies.map(ac => {
    return {
      id: ac.id,
      text: ac.labelSymbol,
      callback: selectCurrency,
    }
  })

  const tableDatesButtonGroup = AVAILABLE_RANGES.map(af => {
    return {
      id: af.id,
      text: t(af.text),
      callback: selectRange,
    }
  })

  return isMobileResolution() ? (
    <TableFiltersMobile
      currencyButtonGroup={currencyButtonGroup}
      tableDatesButtonGroup={tableDatesButtonGroup}
      mobileMenuAnchorEl={mobileMenuAnchorEl}
      mobileMenuOpen={mobileMenuOpen}
      onMobileMenuClose={onMobileMenuClose}
      localStoragePrefix={localStoragePrefix}
    />
  ) : (
    <div
      className={`flex items-center overflow-x-scroll hide-scrollbar desk:justify-between desk:mb-[16px]
				md:justify-between md:overflow-x-visible min-w-[100%]
				 pl-3 lg:pl-0 pr-3 lg:pr-0`}
    >
      <div className="flex items-center min-w-[100%]">
        <div className="flex justify-between min-w-[100%]">
          <div className={"mr-[12px] desk:mr-[16px]"}>
            <div className={`text-[#5B5866] text-xs mb-2`}>
              {t("filter_tit_Currency")}
            </div>
            <PricesButtonGroup
              elements={currencyButtonGroup}
              groupId="currencyGroup"
              localStoragePrefix={localStoragePrefix}
            />
          </div>
          <div className={"ml-[12px] desk:ml-[16px]"}>
            <div className={`text-[#5B5866] text-xs mb-2`}>
              {t("filter_tit_Range")}
            </div>
            <PricesButtonGroup
              elements={tableDatesButtonGroup}
              groupId="rangeGroup"
              localStoragePrefix={localStoragePrefix}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
